import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../core/api.service';
import { Parametric } from '../../cliente/parametric.model';
import { Telefono } from '../../security/user/telefono.model';
import { Email } from '../../security/user/email.model';
import { TelefonoCliente } from '../../cliente/telefonoCliente.model';
import { ParametricWithIcon } from '../../cliente/parametricWithIcon.model';
import { EmailCliente } from '../../cliente/emailCliente.model';

@Component({
  selector: 'app-usuario-datos-contacto',
  templateUrl: './usuario-datos-contacto.component.html',
  styleUrls: ['./usuario-datos-contacto.component.scss']
})
export class UsuarioDatosContactoComponent implements OnInit {

  @Input() telefonos = [];
  @Input() emails = [];
  private tiposTelefonos: ParametricWithIcon[];
  private tiposEmails: ParametricWithIcon[];
  private maxLengthTelefonos = 3;
  private maxLengthEmails = 3;
  private TelefonoCliente = new TelefonoCliente();
  private EmailCliente = new EmailCliente();

  constructor(private apiService: ApiService) { }

  ngOnInit() {
    this.getTiposTelefonos();
    this.getTiposEmails();
  }

  async getTiposTelefonos() {
    this.tiposTelefonos = await this.apiService.get(ParametricWithIcon, ParametricWithIcon.path + 'tipos_telefonos/', null).toPromise();
    for (const tipoTelefono of this.tiposTelefonos) {
      switch (tipoTelefono.id) {
        case this.TelefonoCliente.staticParticular:
          tipoTelefono.icono = 'phone';
          break;
        case this.TelefonoCliente.staticCelular:
          tipoTelefono.icono = 'phone_android';
          break;
        case this.TelefonoCliente.staticLaboral:
          tipoTelefono.icono = 'phonelink_ring';
          break;
        default:
          tipoTelefono.icono = 'phone';
      }
    }
  }
  async getTiposEmails() {
    this.tiposEmails = await this.apiService.get(ParametricWithIcon, ParametricWithIcon.path + 'tipos_email/', null).toPromise();
    for (const tipoEmail of this.tiposEmails) {
      switch (tipoEmail.id) {
        case this.EmailCliente.staticPersonal:
          tipoEmail.icono = 'contact_mail';
          break;
        case this.EmailCliente.staticLaboral:
          tipoEmail.icono = 'email';
          break;
        default:
          tipoEmail.icono = 'email';
      }
    }
  }

  agregarTelefono() {
    this.telefonos.push(new Telefono('', 1));
  }

  agregarEmail() {
    this.emails.push(new Email(1, '', false));
  }

  eliminarTelefono(index: number) {
    this.telefonos.splice(index, 1);
    if (this.telefonos.length === 0) {
      this.agregarTelefono();
    }
  }
  eliminarEmail(index: number) {
    this.emails.splice(index, 1);
    if (this.emails.length === 0) {
      this.agregarEmail();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/usuario-datos-contacto/usuario-datos-contacto.component.ts